<template>
  <div class="packaging-wrapper">
    <app-markets-nav :navItems="navItems"></app-markets-nav>
    <div class="packaging-content">
      <p class="packaging-p indent">Алкомет АД има силно присъствие на европейския пазар.</p>
      <div class="packaging-img" :style="{backgroundImage: 'url(' + '/static/img/markets/packaging/img_1.jpg' + ')'}"></div>
      <h4 class="packaging-h4 indent" id="packaging-1">ДОМАКИНСКО ФОЛИО</h4>
      <p class="packaging-p indent">Домакинското фолио се използва в ежедневеното приготвяне на храна и за запазване на нейната свежест. Неговата отлична устойчивост на най-високите температури при готвене и ролята му като бариера срещу светлина, аромат и пара го правят съществен елемент във всяка кухня.</p>
      <div class="packaging-img" :style="{backgroundImage: 'url(' + '/static/img/markets/packaging/img_2.jpg' + ')'}"></div>
      <h4 class="packaging-h4 indent" id="packaging-2">КОНТЕЙНЕРНО ФОЛИО</h4>
      <p class="packaging-p indent">Домакинското фолио се използва в ежедневеното приготвяне на храна и за запазване на нейната свежест. Неговата отлична устойчивост на най-високите температури при готвене и ролята му като бариера срещу светлина, аромат и пара го правят съществен елемент във всяка кухня.</p>
      <div class="packaging-img" :style="{backgroundImage: 'url(' + '/static/img/markets/packaging/img_3.jpg' + ')'}"></div>
      <h4 class="packaging-h4 indent" id="packaging-3">КОНВЕРТОРНО ФОЛИО</h4>
      <p class="packaging-p indent">Уникалната комбинация от физически характеристики прави алуминиевото фолио съществен материал за хранително-вкусовата промишлесност, като защитен слой на картонени опаковки, обвивки, торбички,  „шапки“ за тапи на бутилки, блистер, ламинирани тръбички.</p>
      <div class="packaging-img" :style="{backgroundImage: 'url(' + '/static/img/markets/packaging/img_4.jpg' + ')'}"></div>
      <h4 class="packaging-h4 indent" id="packaging-4">ЛИСТА "ОМНИЯ"</h4>
      <p class="packaging-p indent">Специален вид листа, ноу-хоу на Алкомет , които се използват за производство на капачки за буркани тип “Омния“ за консервиране на хранителни продукти в домашни условия.</p>
      <app-share-button></app-share-button>
    </div>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import MarketsNav from "./MarketsNav";
export default {
  components: {
    appShareButton: ShareButton,
    appMarketsNav: MarketsNav
  },
  data() {
    return {
      navItems: [
        ["packaging-1", "Домакинско фолио"],
        ["packaging-2", "Контейнерно фолио"],
        ["packaging-3", "Конверторно фолио"],
        ["packaging-4", "Листа Омния"]
      ]
    };
  }
};
</script>

<style scoped>
.packaging-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
/* CONTENT */
.packaging-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 80%;
}
.packaging-p {
  font-size: 19px;
  margin: 15px 0;
  text-align: justify;
  line-height: 32px;
  width: 60%;
}
.packaging-link {
  font-size: 19px;
  text-decoration: underline;
}
.packaging-h4 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px 0;
  text-align: justify;
  width: 60%;
}
.packaging-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  min-height: 280px;
  margin: 20px 0;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .packaging-content {
    width: 100%;
  }
  .packaging-h4 {
    font-size: 18px;
    padding: 0 30px;
    width: 100%;
  }
  .packaging-p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .packaging-link {
    font-size: 16px;
  }
  .packaging-img {
    min-height: 30vw;
    margin: 20px 30px;
    width: calc(100% - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/markets/Packaging.vue